import { buildModelManager } from "../builder.js";
const DefaultShiftDocumentationSelection = {
  __typename: true,
  id: true,
  additionalDocuments: true,
  appliedShiftPackId: true,
  attendanceMethod: true,
  attendanceOverrideReason: true,
  attendanceSignature: { url: true, mimeType: true, fileName: true },
  attendanceVerified: true,
  attendanceVerifiedAt: true,
  attendanceVerifiedById: true,
  attendanceViolations: true,
  attendedAt: true,
  challengesFaced: { markdown: true, truncatedHTML: true },
  checkInAt: true,
  checkInDeviceIp: true,
  checkInDistanceMeters: true,
  checkInLatitude: true,
  checkInLongitude: true,
  checkInWithinGeofence: true,
  checkOutAt: true,
  checkOutDeviceIp: true,
  checkOutDistanceMeters: true,
  checkOutLatitude: true,
  checkOutLongitude: true,
  checkOutWithinGeofence: true,
  competenciesAssessed: true,
  completionStatus: true,
  createdAt: true,
  enrolledAt: true,
  enrollmentStatus: true,
  evaluationForm: { url: true, mimeType: true, fileName: true },
  formChecklist: true,
  isComplete: true,
  lastAttendanceCheckInReminderSentAt: true,
  lastAttendanceCheckOutReminderSentAt: true,
  lastAttendanceViolationNotifiedAt: true,
  lastModifiedAt: true,
  lastPackReminderSentAt: true,
  learningObjectives: { markdown: true, truncatedHTML: true },
  learningOutcomes: { markdown: true, truncatedHTML: true },
  missingRequirements: true,
  postShiftReflection: { markdown: true, truncatedHTML: true },
  preShiftNotes: { markdown: true, truncatedHTML: true },
  preceptorId: true,
  requirementsMet: true,
  shiftId: true,
  skillsPracticed: true,
  studentId: true,
  submittedAt: true,
  updatedAt: true
};
const modelApiIdentifier = "shiftDocumentation";
const pluralModelApiIdentifier = "shiftDocumentations";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShiftDocumentationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShiftDocumentationSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShiftDocumentationSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShiftDocumentationSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShiftDocumentationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShiftDocumentationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShiftDocumentationSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createShiftDocumentation",
    operationReturnType: "CreateShiftDocumentation",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      shiftDocumentation: { required: false, type: "CreateShiftDocumentationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShiftDocumentationSelection
  },
  {
    type: "action",
    operationName: "bulkCreateShiftDocumentations",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateShiftDocumentationsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultShiftDocumentationSelection
  },
  {
    type: "action",
    operationName: "updateShiftDocumentation",
    operationReturnType: "UpdateShiftDocumentation",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      shiftDocumentation: { required: false, type: "UpdateShiftDocumentationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShiftDocumentationSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateShiftDocumentations",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateShiftDocumentationsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultShiftDocumentationSelection
  },
  {
    type: "action",
    operationName: "deleteShiftDocumentation",
    operationReturnType: "DeleteShiftDocumentation",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteShiftDocumentations",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertShiftDocumentation",
    operationReturnType: "UpsertShiftDocumentation",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      shiftDocumentation: { required: false, type: "UpsertShiftDocumentationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateShiftDocumentationResult": { hasReturnType: false },
      "... on UpdateShiftDocumentationResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShiftDocumentationSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertShiftDocumentations",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertShiftDocumentationsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultShiftDocumentationSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "shiftDocumentationGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ShiftDocumentationManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShiftDocumentationSelection,
  operations
);
export {
  DefaultShiftDocumentationSelection,
  ShiftDocumentationManager
};
//# sourceMappingURL=ShiftDocumentation.js.map
